export const setProgrammeFetchStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_FETCH_STATUS_ACTION', payload: status }
}
export const setProgrammeCreateStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_CREATE_STATUS_ACTION', payload: status }
}

export const setIsNewProgrammeAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_NEW_PROGRAMME_ACTION', payload: status }
}

export const setIsNewEpisodeAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_NEW_EPISODE_ACTION', payload: status }
}

export const setProgrammeFetchResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_FETCH_RESULT_ACTION', payload: result }
}

export const setProgrammeOriginalAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_PROGRAMME_ACTION', payload: result }
}

export const setProgrammeEpisodesFetchResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_EPISODES_ACTION', payload: result }
}

export const setProgrammeOriginalAggregateVersionAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_VERSION_ACTION', payload: result }    
}

export const setProgrammeDraftResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ACTION', payload: result }
}

export const setProgrammeDraftResultsTitlesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_TITLES_ACTION', payload: result }
}
export const clearProgrammeDraftResultsTitlesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_TITLES_ACTION', payload: result }
}        

export const setProgrammeDraftResultsMasterIdaAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_MASTERIDA_ACTION', payload: result }
}

export const setProgrammeDraftResultsAnimeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ANIME_ACTION', payload: result }
}

export const setProgrammeDraftResultsIsRadioAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_ISRADIO_ACTION', payload: result }
}

export const setProgrammeDraftResultsLanguageAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_LANGUAGE_ACTION', payload: result }
}

export const setProgrammeDraftResultsProgrammeTypeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_PROGRAMMETYPE_ACTION', payload: result }
}

export const setProgrammeDraftResultsFormatTypeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_FORMATTYPE_ACTION', payload: result }
}

export const setProgrammeOriginalResultsSapCodeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_ORIGINAL_RESULT_SAPCODE_ACTION', payload: result }
}

export const setProgrammeDraftResultsProductionCompaniesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_PRODUCTIONCOMPANIES_ACTION', payload: result }
}

export const setProgrammeDraftResultsCountryAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_COUNTRY_ACTION', payload: result }
}

export const setProgrammeDraftResultsEpisodesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_DRAFT_RESULT_EPISODES_ACTION', payload: result }
}

export const clearProgrammeDraftResultsEpisodesAction = (isSaveComplete = false) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_EPISODES_ACTION', payload: { isSaveComplete } }
}

export const clearProgrammeDraftResultsCountryAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_COUNTRY_ACTION', payload: result }
}

export const clearProgrammeDraftResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ACTION', payload: result }
}

export const clearProgrammeDraftResultsProgrammeTypeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_PROGRAMMETYPE_ACTION', payload: result }
}

export const clearProgrammeDraftResultsFormatTypeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_FORMATTYPE_ACTION', payload: result }
}

export const clearProgrammeDraftResultsIsRadioAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ISRADIO_ACTION', payload: result }
}

export const clearProgrammeDraftResultsMasterIdaAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_MASTERIDA_ACTION', payload: result }
}

export const clearProgrammeDraftResultsAnimeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_ANIME_ACTION', payload: result }
}

export const clearProgrammeDraftResultsLanguageAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_LANGUAGE_ACTION', payload: result }
}

export const clearProgrammeDraftResultsProductionCompaniesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_PRODUCTIONCOMPANIES_ACTION', payload: result }
}

export const setProgrammeGuidAction = (guid) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_GUID', payload: guid }
}

export const clearProgrammeGuidAction = () => {
    return { type: 'DATAENTRY_AUDIOVISUAL_CLEAR_GUID'}
}

export const setEpisodeFetchStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODEFETCH_STATUS_ACTION', payload: status }
}

export const setEpisodeFetchResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODEFETCH_RESULT_ACTION', payload: result }
}

export const setEpisodeGuidAction = (guid) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODEGUID', payload: guid }
}

export const setEpisodeOriginalResultsSapCodeAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_ORIGINAL_RESULT_SAPCODE_ACTION', payload: result }
}

export const clearEpisodeResultsAction = () => {
    return { type: 'DATAENTRY_AUDIOVISUAL_CLEAR_EPISODE_RESULTS_ACTION'}
}

export const setEpisodeDraftResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_RESULT_ACTION', payload: result }
}

export const setEpisodeDraftResultsTransmissionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_TRANSMISSIONS_ACTION', payload: result }
}

export const setEpisodeDraftResultsTitleAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_RESULT_TITLE_ACTION', payload: result }
}

export const clearEpisodeDraftResultsTransmissionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_TRANSMISSIONS_ACTION', payload: result }
}

export const undoClearEpisodeDraftResultsTransmissionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_UNDO_DELETE_DRAFT_TRANSMISSIONS_ACTION', payload: result }
}

export const clearEpisodeResultsTransmissionsFromDraftsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_TRANSMISSION_ACTION', payload: result }
}

export const setEpisodeDraftResultsContributionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_CONTRIBUTIONS_ACTION', payload: result }
}

export const clearEpisodeDraftResultsContributionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_CONTRIBUTIONS_ACTION', payload: result }
}

export const undoClearEpisodeDraftResultsContributionsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_UNDO_DELETE_DRAFT_CONTRIBUTIONS_ACTION', payload: result }
}

export const clearEpisodeResultsContributionsFromDraftsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_CONTRIBUTION_ACTION', payload: result }
}

export const clearEpisodeResultsTitleFromDraftsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_EPISODE_DRAFT_RESULT_TITLE_ACTION', payload: result }
}

//Programme Update

export const setProgrammeUpdateStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMMEUPDATE_STATUS_ACTION', payload: status }
}

export const setProgrammeUpdateResultsAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMMEUPDATE_RESULT_ACTION', payload: result }
}

// Programme Update Audit Data
export const setProgrammeUpdateAuditDataAction = (date, name) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMME_UPDATE_AUDITDATA_ACTION', payload: { date, name }}
}

// Programme Create Audit Data
export const setProgrammeCreateAuditDataAction = (date, name) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_PROGRAMME_CREATE_AUDITDATA_ACTION', payload: { date, name } }
}

// Episode Create Audit Data
export const setEpisodeCreateAuditDataAction = (date, name) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_CREATE_AUDITDATA_ACTION', payload: { date, name } }
}

// Episode Update Audit Data
export const setEpisodeUpdateAuditDataAction = (date, name) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_UPDATE_AUDITDATA_ACTION', payload: { date, name }}
}

//Episode Duration

export const setEpisodeDraftResultDurationAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_DURATION_ACTION', payload: result }
}

export const clearEpisodeDraftResultsDurationAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_DURATION_ACTION', payload: result }
}

//Episode Year Of Production

export const setEpisodeDraftResultYearOfProductionAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_YEAR_ACTION', payload: result }
}

export const clearEpisodeDraftResultsYearOfProductionAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_YEAR_ACTION', payload: result }
}

//Episode ida

export const setEpisodeDraftResultIdaAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_IDA_ACTION', payload: result }
}

export const clearEpisodeDraftResultsIdaAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_IDA_ACTION', payload: result }
}

//Episode Update Status

export const setEpisodeUpdateStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODEUPDATE_STATUS_ACTION', payload: status }
}

export const setEpisodeSaveAndExitClickedAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_SAVE_AND_EXIT_CLICKED_ACTION', payload: status }
}

//Episode List update status

export const setEpisodeListUpdateStatusAction = (status) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODELISTUPDATE_STATUS_ACTION', payload: status }
}

//Episode Series

export const setEpisodeDraftResultSeriesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_SERIES_ACTION', payload: result }
}

export const clearEpisodeDraftResultsSeriesAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_SERIES_ACTION', payload: result }
}

//Episode Number

export const setEpisodeDraftResultNumberAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_SET_EPISODE_DRAFT_NUMBER_ACTION', payload: result }
}

export const clearEpisodeDraftResultsNumberAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_EPISODE_DELETE_DRAFT_NUMBER_ACTION', payload: result }
}

export const setShowDataUpdateAction = (show) => {
    return { type: 'DATAENTRY_SET_SHOW_DATA_UPDATE', payload: show }
}

export const setShowDataCreateAction = (show) => {
    return { type: 'DATAENTRY_SET_SHOW_DATA_CREATE', payload: show }   
}

export const setDataUpdateKeyAction = (key) => {
    return { type: 'DATAENTRY_SET_DATA_UPDATE_KEY', payload: key } 
}

export const setShowEpisodeDataUpdateAction = (show) => {
    return { type: 'DATAENTRY_SET_SHOW_EPISODE_DATA_UPDATE', payload: show }
}

export const setShowEpisodeDataCreateAction = (show) => {
    return { type: 'DATAENTRY_SET_SHOW_EPISODE_DATA_CREATE', payload: show }
}

export const setEpisodeDataUpdateKeyAction = (key) => {
    return { type: 'DATAENTRY_SET_EPISODE_DATA_UPDATE_KEY', payload: key }
}

export const setAreEpisodeLanguagesInvalid = (areEpisodeLanguagesInvalid) => {
    return { type: 'DATAENTRY_SET_ARE_EPISODE_LANGUAGES_INVALID', payload: areEpisodeLanguagesInvalid }
}

export const setAreEpisodeTitlesInvalid = (areEpisodeTitlesInvalid) => {
    return { type: 'DATAENTRY_SET_ARE_EPISODE_TITLES_INVALID', payload: areEpisodeTitlesInvalid }
}

export const setEpisodeTitles = (episodeDetails) => {
    return { type: 'DATAENTRY_SET_EPISODE_TITLES', payload: episodeDetails }
}

export const setAreProgrammeLanguagesInvalidAction = (areProgrammeLanguagesInvalid) => {
    return { type: 'DATAENTRY_SET_ARE_PROGRAMME_LANGUAGES_INVALID', payload: areProgrammeLanguagesInvalid }
}

export const setAreProgrammeTitlesInvalidAction = (areProgrammeTitlesInvalid) => {
    return { type: 'DATAENTRY_SET_ARE_PROGRAMME_TITLES_INVALID', payload: areProgrammeTitlesInvalid }
}

export const setProgrammeTitlesAction = (programmeDetails) => {
    return { type: 'DATAENTRY_SET_PROGRAMME_TITLES', payload: programmeDetails }
}

export const setPrimaryTitleAction = (programmeDetails) => {
    return { type: 'DATAENTRY_SET_PROGRAMME_PRIMARY_TITLE', payload: programmeDetails }
}

export const setIsProgrammePrimaryTitleInvalidAction = (isPrimaryTitleInvalid) => {
    return { type: 'DATAENTRY_SET_ARE_PROGRAMME_TITLES_INVALID', payload: isPrimaryTitleInvalid }
}

export const clearProgrammeDraftResultsEpisodesListAction = (result) => {
    return { type: 'DATAENTRY_AUDIOVISUAL_DELETE_DRAFT_EPISODES_LIST_ACTION', payload: result }
}

//To enable / disable SAVE when in edit mode

export const episodeListstartEditing = () => {
    return { type: 'DATAENTRY_EPISODELIST_START_EDITING' }
}

export const episodeListstopEditing = () => {
    return { type: 'DATAENTRY_EPISODELIST_STOP_EDITING' }
}

// Contribution editing state actions
export const contributionStartEditing = () => {
    return { type: 'DATAENTRY_CONTRIBUTION_START_EDITING' }
}

export const contributionStopEditing = () => {
    return { type: 'DATAENTRY_CONTRIBUTION_STOP_EDITING' }
}

export const setAudiovisualFilterAction = (filter) => {
    return { type: 'DATAENTRY_SET_FILTER', payload: filter }
}

export const setAudiovisualSortAction = (sort) => {
    return { type: 'DATAENTRY_SET_SORT', payload: sort }
}
export const setAudiovisualRefreshAction = (refresh) => {
    return { type: 'DATAENTRY_SET_REFRESH', payload: refresh }
}

export const setEpisodeListCurrentPageAction = (page) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_CURRENT_PAGE', payload: page })
export const setEpisodeListFirstAction = (first) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_FIRST', payload: first })
export const setEpisodeListRowsAction = (rows) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_ROWS', payload: rows })
export const setEpisodeListTotalPagesAction = (total) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_TOTAL_PAGES', payload: total })
export const setEpisodeListFetchStatusAction = (status) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_FETCH_STATUS', payload: status })
export const setEpisodeListPageDataAction = (data) => ({ type: 'DATAENTRY_SET_EPISODE_LIST_PAGE_DATA', payload: data })